<button
  class="g-btn"
  [class.g-btn-transparent]="isTransparent()"
  [class.g-btn-default]="isStyleDefault()"
  [class.g-btn-small]="buttonSize() === 'small'"
  [class.g-btn-large]="buttonSize() === 'large'"
  [class.g-btn-bold]="isBold()"
  [disabled]="isDisabled() || (isLoading() && isDisabledOnLoading())"
  [type]="buttonType()"
>
  @if (leftIconName(); as icon) {
    <tc-icon
      [name]="icon"
      aria-hidden="true"
    />
  }
  <ng-content />
  @if (rightIconName(); as icon) {
    <tc-icon
      [name]="icon"
      aria-hidden="true"
    />
  }

  @if (isLoading()) {
    <preloader class="g-btn-preloader"/>
  }
</button>
